import { render, staticRenderFns } from "./BCarouselListMod.vue?vue&type=template&id=0d18f6de&scoped=true&"
import script from "./BCarouselListMod.vue?vue&type=script&lang=js&"
export * from "./BCarouselListMod.vue?vue&type=script&lang=js&"
import style0 from "./BCarouselListMod.vue?vue&type=style&index=0&id=0d18f6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18f6de",
  null
  
)

export default component.exports